let numeral = require("numeral");
import Vue from 'vue';

Vue.filter('amount', function (value) {
   return value != null ? numeral(value).format("0,0") : null;
});